module.exports = __webpack_public_path__ + "img/start-2.9c926394.png";